/** Pure fetch wrapper for step-up (M2): inject X-Stepup-Token, keep the refreshed one,
 *  and on 428 ask the UI for a step-up then retry once. `url` is the original relative URL
 *  used for routing; `input` is what is actually fetched (may be rewritten to absolute). */
import { appForUrl, getStepupToken, requestStepup, setStepupToken } from './stepupStore.ts'

export async function stepupFetch(
  doFetch: typeof fetch,
  url: string,
  input: RequestInfo | URL,
  init: RequestInit | undefined,
  headers: Headers,
): Promise<Response> {
  const app = appForUrl(url)
  if (!app) return doFetch(input, { ...init, headers })

  const send = async () => {
    const h = new Headers(headers)
    const token = getStepupToken(app)
    if (token) h.set('X-Stepup-Token', token)
    const r = await doFetch(input, { ...init, headers: h })
    const refreshed = r.headers.get('X-Stepup-Token')
    if (refreshed) setStepupToken(app, refreshed)
    return r
  }

  const first = await send()
  // A Request body stream can only be read once: retry only string/URL inputs.
  if (first.status !== 428 || input instanceof Request) return first
  const ok = await requestStepup(app)
  return ok ? send() : first
}
